import React from 'react';
import cn from 'clsx';

import { Image, UIHeading4, UIText2, useDeviceType } from '@cian/ui-kit';

import styles from './styles.css';

export interface IBorderWrapperProps {
  imgUrl: string;
  title: string;
  description?: string;
  button: React.ReactNode;
  testId?: string;
}

export const BorderBlock: React.FC<IBorderWrapperProps> = ({ imgUrl, title, description, button, testId }) => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles.root, styles[deviceType])} data-testid={testId}>
      {imgUrl && (
        <div className={cn(styles['image'], styles[deviceType])}>
          <Image src={imgUrl} />
        </div>
      )}
      <div className={styles['title']}>
        <UIHeading4>{title}</UIHeading4>
      </div>
      {description && (
        <div className={cn(styles['description'], styles[deviceType])}>
          <UIText2>{description}</UIText2>
        </div>
      )}
      {button && button}
    </div>
  );
};

BorderBlock.displayName = 'BorderWrapper';
